import { NgModule } from '@angular/core';
import { SharedModule } from 'projects/shared/src/lib/shared';

import { SideBarActionsModule } from './actions/side-bar-actions.module';
import { SideBarHeaderModule } from './header/side-bar-header.module';
import { SideBarNavigationModule } from './navigation/side-bar-navigation.module';
import { SideBarComponent } from './side-bar.component';

@NgModule({
  imports: [
    SharedModule,
    SideBarActionsModule,
    SideBarHeaderModule,
    SideBarNavigationModule
  ],
  declarations: [SideBarComponent],
  exports: [
    SideBarComponent,
    SideBarActionsModule,
    SideBarHeaderModule,
    SideBarNavigationModule
  ]
})
export class SideBarModule { }
